// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcgsUgkQUgzu9jR3c4Sggf2jE67tK3l9A",
  authDomain: "thread-funder.firebaseapp.com",
  projectId: "thread-funder",
  storageBucket: "thread-funder.appspot.com",
  messagingSenderId: "622659955293",
  appId: "1:622659955293:web:745b2e417aac86ec6ebbb4",
  measurementId: "G-P1Q17RZDTY",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
